import React, { useEffect, useState } from "react";
import { Grid, Box, Button, Typography } from "../../../components/ui";
import axiosInstance from "../../../axios/axiosInstance";
import { toast } from "react-toastify";
import { handeleUpdateStatus } from "../../../utils/update-request-status";

interface Prop {
  requestData?: any;
  onClose?: () => void;
  requestId?: any;
}
const DeleteVehicle: React.FC<Prop> = ({ requestData, onClose, requestId }) => {
  const role = localStorage.getItem("role");
  const [data, setData] = useState<any>(null);

  console.log(requestData, requestData?.id);

  const handleGetVehicle = async (id: any) => {
    try {
      const resp: any = await axiosInstance.get(`/api/vehicle/${id}`);
      if (resp.status === 200) {
        setData(resp?.data?.data);
      }
    } catch (Error: any) {
      toast.error(Error?.response?.data?.body);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      // When approving a request, execute directly without invocation
      const url = requestId 
        ? `/api/vehicle/${requestData?.data?.id}` 
        : `/api/vehicle/${requestData?.data?.id}?invocation=${role}`;
      
      const resp: any = await axiosInstance.delete(url);
      if (resp.status === 200) {
        if (requestId) {
          handeleUpdateStatus(requestId, "1");
        }
        if (requestId) {
          toast.success("Request approved and vehicle deleted successfully");
        } else {
          toast.success("Vehicle deleted successfully");
        }
        onClose?.();
      }
    } catch (Error: any) {
      toast.error(Error?.response?.data?.body || Error?.message);
    }
  };
  useEffect(() => {
    handleGetVehicle(requestData?.data?.id);
  }, [requestData]);

  return (
    <div>
      <Grid container>
        <Grid size={12}>
          <Typography fontSize={18} fontWeight={500} color="#1F2937">
            Delete Vehicle
          </Typography>
        </Grid>

        <Grid size={12} borderBottom={"1px solid #1F2937"}>
          <Typography fontSize={17} fontWeight={600} color="#1F2937">
            Vehicle Details
          </Typography>
        </Grid>
        <Grid size={12}>
          <Typography fontSize={16} fontWeight={500} color="#1F2937">
            Vehicle No: {data?.reg_no}
          </Typography>
        </Grid>
        <Grid size={12}>
          <Typography fontSize={16} fontWeight={500} color="#1F2937">
            Vehicle Type: {data?.type}
          </Typography>
        </Grid>

        <Grid size={12} borderBottom={"1px solid #1F2937"}>
          <Typography fontSize={17} fontWeight={600} color="#1F2937">
            User Details
          </Typography>
        </Grid>

        <Grid size={12} mt={1}>
          <Typography fontSize={16} fontWeight={500} color="#1F2937">
            Name: {data?.user?.name}
          </Typography>
        </Grid>
        <Grid size={12} mt={1}>
          <Typography fontSize={16} fontWeight={500} color="#1F2937">
            Member Type: {data?.user?.member_type}
          </Typography>
        </Grid>
        <Grid size={12} mt={1}>
          <Typography fontSize={16} fontWeight={500} color="#1F2937">
            Phone: {data?.user?.phone}
          </Typography>
        </Grid>

        <Grid size={12}>
          <Grid size={12} display={"flex"} justifyContent={"end"}>
            {" "}
            <Box display={"display"}>
              <Button
                size="small"
                variant="contained"
                sx={{ mx: 1, bgcolor: "#1F2937" }}
                onClick={handleDelete}
              >
                Delete
              </Button>

              <Button
                size="small"
                variant="outlined"
                sx={{ color: "#1F2937", borderColor: "#1F2937" }}
                onClick={onClose}
              >
                Close
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default DeleteVehicle;
